"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForceRedraw = void 0;
var _react = require("react");
/**
 * @returns Redraw function which can be called to force-rerender current react component.
 */
const useForceRedraw = () => {
  // eslint-disable-next-line react/hook-use-state -- The actual state value not needed here.
  const [, setReRendered] = (0, _react.useState)(Date.now());
  return (0, _react.useCallback)(() => setReRendered(Date.now()), []);
};
exports.useForceRedraw = useForceRedraw;